import { EventEmitter } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export class FormUtil {
  public static markAsTouched(form: FormGroup): void {
    for (let [key, control] of Object.entries(form.controls)) {
      control.markAsTouched();
      control.updateValueAndValidity();
    }
  }

  public static addError(control: AbstractControl | null, errors: ValidationErrors) {
    if (control == null) {
      return;
    }

    if (control.errors == null) {
      control.setErrors(errors);
    } else {
      control.setErrors({...control.errors, ...errors});
    }
  }

  public static removeError(control: AbstractControl | null, errorKey: string): void {
    if (control == null || control.errors == null || control.errors[errorKey] == null) {
      return;
    }

    let errors = control.errors;
    delete errors[errorKey];
    control.setErrors(Object.keys(errors).length === 0 ? null : errors);
  }
}
